<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-1">
<p class="title">D<span class="small">EFENDING</span> T<span class="small">HE</span> A<span class="small">RTERIES</span> <span class="small">OF</span>  R<span class="small">EBELLION</span></p>
<p class="title1">Confederate Naval Operations </p>
<p class="title1">in the Mississippi River Valley, 1861-1865</p>
<p class="title2">Neil P. Chatelain</p>
<div class="img_container_">
<img alt="image" src="images/logo.jpg"/>
</div>
<p class="title3"><span class="bold">Savas Beatie</span></p>
<p class="title3"><span class="bold">California</span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 001_Title.vue?2c6875cc